import React from "react";
import PropTypes from "prop-types";
import { ExcelExport, ExcelExportColumn } from "@progress/kendo-react-excel-export";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";

export const OrganizationGridContent = ({
  expandedResult,
  dataResult,
  dataState,
  onDataStateChange,
  onSelectionChange,
  onHeaderSelectionChange,
  handleRowClick,
  DATA_ITEM_KEY,
  SELECTED_FIELD,
  checkHeaderSelectionValue,
  columns,
  _export,
  exportFileName,
}) => {
  return (
    <div className="configurable-list-container">
      <ExcelExport data={dataResult.data} ref={_export} fileName={exportFileName}>
        {columns.map((col, index) => (
          col.export && <ExcelExportColumn key={index} field={col.field} title={col.title} />
        ))}
      </ExcelExport>
      <Grid
        data={expandedResult}
        pageable={{
          info: true,
          pageSizes: [10, 25, 50, 75, 100],
        }}
        groupable={true}
        reorderable={true}
        resizable={true}
        skip={dataState.skip}
        take={dataState.take}
        total={dataResult.total}
        sortable={true}
        sort={dataState.sort}
        onRowClick={handleRowClick}
        {...dataState}
        onDataStateChange={onDataStateChange}
        dataItemKey={DATA_ITEM_KEY}
        selectedField={SELECTED_FIELD}
        onHeaderSelectionChange={onHeaderSelectionChange}
        onSelectionChange={onSelectionChange}
      >
        <Column
          filterable={false}
          field={SELECTED_FIELD}
          width={50}
          headerSelectionValue={checkHeaderSelectionValue()}
        />
        {columns.map((col, index) => (
          col.render && <Column key={index} field={col.field} title={col.title} cells={col.cells} />
        ))}
      </Grid>
    </div>
  );
};

OrganizationGridContent.propTypes = {
  expandedResult: PropTypes.array.isRequired,
  dataResult: PropTypes.object.isRequired,
  dataState: PropTypes.object.isRequired,
  onDataStateChange: PropTypes.func,
  onSelectionChange: PropTypes.func,
  onHeaderSelectionChange: PropTypes.func,
  handleRowClick: PropTypes.func,
  DATA_ITEM_KEY: PropTypes.string.isRequired,
  SELECTED_FIELD: PropTypes.string.isRequired,
  checkHeaderSelectionValue: PropTypes.func,
  columns: PropTypes.array.isRequired,
  _export: PropTypes.object.isRequired,
  exportFileName: PropTypes.string.isRequired,
};
